'use client'

import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import {
  getStorage,
  removeStorage,
  STORAGE_KEY,
  useDialog,
  useSession,
} from '@/shared/lib'
import { AlertDialog } from '@/shared/ui'

const DIALOG = {
  BLOCKED_USER: 'BLOCKED_USER',
} as const

type MainDialog = keyof typeof DIALOG

export const BlockedUserDialog = () => {
  const session = useSession()
  const { isOpen, open, closeHandler } = useDialog<MainDialog>()

  const t = useTranslations('common')

  useEffect(() => {
    const isBlockedUser = session.data?.blocked
    const showBlockedUserDialog =
      getStorage(STORAGE_KEY.SHOW_BLOCKED_USER_DIALOG) === 'true'

    if (showBlockedUserDialog && isBlockedUser) {
      open(DIALOG.BLOCKED_USER)
    }

    removeStorage(STORAGE_KEY.SHOW_BLOCKED_USER_DIALOG)
  }, [])

  return (
    <AlertDialog
      isOpen={isOpen(DIALOG.BLOCKED_USER)}
      onOpenChange={closeHandler(DIALOG.BLOCKED_USER)}
      title={t('dialog.title')}
      content={t('dialog.description')}
    />
  )
}
